import { render, staticRenderFns } from "./LightCheckout.vue?vue&type=template&id=634ef75b&scoped=true&"
import script from "./LightCheckout.vue?vue&type=script&lang=js&"
export * from "./LightCheckout.vue?vue&type=script&lang=js&"
import style0 from "./LightCheckout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LightCheckout.vue?vue&type=style&index=1&id=634ef75b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ef75b",
  null
  
)

export default component.exports